import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";

interface ProjectCardProps {
  project: {
    _id: string | number;
    title: string;
    location: string;
    year: string;
    description: string;
    image: string;
  };
}

export function ProjectCard({ project }: ProjectCardProps) {
  return (
    <div className="group overflow-hidden rounded-xl border bg-card shadow-sm transition-all hover:shadow-md">
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={project.image || "/placeholder.svg"}
          alt={project.title}
          className="h-full w-full object-cover transition-transform group-hover:scale-105"
        />
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-muted-foreground">
            {project.location}
          </span>
          <span className="text-sm font-medium text-muted-foreground">
            {project.year}
          </span>
        </div>
        <h3 className="text-xl font-bold">{project.title}</h3>
        <p className="mt-2 text-muted-foreground line-clamp-2">
          {project.description}
        </p>
        <div className="mt-4">
          <Link to={`/portfolio/${project._id}`}>
            <Button
              variant="outline"
              size="sm"
              className=" bg-[#484331] hover:bg-[#3e3a2b] text-white"
            >
              View Project
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
